import type { LayoutProps as Props } from './types';
import { withChildren } from '@builder.io/react';
import { cls } from '@/utils/cls';
import style from './Layout.module.scss';
export function Layout({
  extendStyles,
  children
}: Props) {
  if (!children || children.length === 0) {
    return <div>Please Add Some Child Components!</div>;
  }
  const _className = cls(style.root, extendStyles);
  const controlledComponents = ['Header', 'Form', 'SingleForm', 'Hero', 'SecondaryHero', 'LogoBar', 'MainHeader', 'TrapezoidHero', 'ContactUs', 'BragBar'];

  // get the controlled components for the layout
  const header = children.find(e => e.props.block.component.name === 'Header') || null;
  const mainHeader = children.find(e => e.props.block.component.name === 'MainHeader') || null;
  const form = children.find(e => e.props.block.component.name === 'Form') || null;
  const hero = children.find(e => e.props.block.component.name === 'Hero') || null;
  const trapezoidHero = children.find(e => e.props.block.component.name === 'TrapezoidHero') || null;
  const secondaryHero = children.find(e => e.props.block.component.name === 'SecondaryHero') || null;
  const logoBar = children.find(e => e.props.block.component.name === 'LogoBar') || null;
  const bragBar = children.find(e => e.props.block.component.name === 'BragBar') || null;
  const contactUs = children.find(e => e.props.block.component.name === 'ContactUs') || null;
  const IconList = children.find(e => e.props.block.component.name === 'IconList' && e.props.block.component.options.secondaryHeroLoc) || null;

  // remove the controlled components for the rest of the page
  const filteredChildren = children.filter(e => {
    // might be duplicate of IconList, remove it
    if (e.props.block.id === IconList?.props.block.id) {
      return null;
    }
    return !controlledComponents.includes(e.props.block.component.name);
  });
  return <main id="base" className={_className} data-sentry-component="Layout" data-sentry-source-file="Layout.tsx">
			{header || mainHeader}
			<section className={style.upper}>
				{hero || trapezoidHero}
				{logoBar || bragBar}
				{secondaryHero || IconList}
				{contactUs}
				{form && <aside data-testid="Aside">{form}</aside>}
			</section>
			<section className={style.lower}>{filteredChildren}</section>
		</main>;
}
export default withChildren(Layout);